import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { fetchProducts } from "@/lib/shopify";
import { ProductCard, ProductCardSkeleton } from "@/components/ProductCard";

interface Props {
  /** Tag of the current product (Field, Western, Lifestyle) for matching */
  tag?: string;
  /** Handle of the current product to exclude from results */
  excludeHandle: string;
  /** Heading text */
  title?: string;
}

export function RelatedProducts({ tag, excludeHandle, title = "You May Also Like" }: Props) {
  const { data: products, isLoading } = useQuery({
    queryKey: ["related", tag ?? "all"],
    queryFn: () => (tag ? fetchProducts(8, `tag:${tag}`) : fetchProducts(8)),
  });

  const filtered = (products ?? []).filter((p) => p.node.handle !== excludeHandle).slice(0, 4);

  return (
    <section className="border-t border-[#D4CCBC] bg-[#F5EFE2] py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-6">
        <div className="mb-10 flex items-end justify-between">
          <h2 className="font-heading text-3xl font-bold uppercase tracking-[0.1em] text-[#2A1510] md:text-4xl">
            {title}
          </h2>
          <Link
            to="/collections/$collection"
            params={{ collection: "all-hats" }}
            className="hidden font-ui text-xs font-bold uppercase tracking-[0.2em] text-[#FA5021] underline-offset-4 hover:underline md:inline"
          >
            Shop All →
          </Link>
        </div>

        <div className="grid gap-6 grid-cols-2 md:grid-cols-3 xl:grid-cols-4">
          {isLoading
            ? Array.from({ length: 4 }).map((_, i) => <ProductCardSkeleton key={i} />)
            : filtered.map((p) => <ProductCard key={p.node.id} product={p} />)}
        </div>
      </div>
    </section>
  );
}
